// Security utilities for cleaning up sensitive data

export const clearSensitiveData = () => {
  try {
    // Clear any anon keys or other sensitive data that shouldn't be stored
    const keysToRemove = [];
    
    // Get all localStorage keys
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (
        key.includes('anon_key') ||
        key.includes('supabase.anon.key') ||
        key.includes('supabase.anon') ||
        // Don't remove auth tokens - they're needed for authentication
        // key.includes('supabase.auth.token') ||
        // key.includes('access_token') ||
        // key.includes('refresh_token') ||
        key.includes('supabase.auth.anon')
      )) {
        keysToRemove.push(key);
      }
    }
    
    // Remove sensitive keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
  } catch (error) {
    console.warn('Error clearing sensitive data:', error);
  }
};

export const checkForSensitiveData = () => {
  try {
    const sensitiveKeys = [];
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (
        key.includes('anon_key') ||
        key.includes('supabase.anon.key') ||
        key.includes('supabase.anon') ||
        key.includes('supabase.auth.anon')
        // Don't check for auth tokens - they're needed
        // key.includes('supabase.auth.token') ||
        // key.includes('access_token') ||
        // key.includes('refresh_token')
      )) {
        sensitiveKeys.push(key);
      }
    }
    
    if (sensitiveKeys.length > 0) {
      console.warn('Found sensitive data in localStorage:', sensitiveKeys);
      return true;
    }
    
    return false;
  } catch (error) {
    console.warn('Error checking for sensitive data:', error);
    return false;
  }
};

// Only run cleanup if explicitly called, not on import
// clearSensitiveData(); // Removed automatic cleanup 